import { render, staticRenderFns } from "./ShortcutsModalContent.vue?vue&type=template&id=d22f8434&scoped=true"
import script from "./ShortcutsModalContent.vue?vue&type=script&lang=js"
export * from "./ShortcutsModalContent.vue?vue&type=script&lang=js"
import style0 from "./ShortcutsModalContent.vue?vue&type=style&index=0&id=d22f8434&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22f8434",
  null
  
)

export default component.exports